import { render, staticRenderFns } from "./Copyable.vue?vue&type=template&id=0c6b2256&"
import script from "./Copyable.vue?vue&type=script&lang=ts&"
export * from "./Copyable.vue?vue&type=script&lang=ts&"
import style0 from "./Copyable.vue?vue&type=style&index=0&id=0c6b2256&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports